import { Component, Input } from '@angular/core';

@Component({
    selector: 'behavioral-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 25.61"
            [attr.width]="dimensions.width"
            [attr.height]="dimensions.height"
        >
            <title>Behavioral</title>

            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path
                        d="M16.84,19.3a3.16,3.16,0,0,0-2.7,1.51l-8-3.94a3.17,3.17,0,0,0,0-2l8-3.6a3.16,3.16,0,1,0,0-3.53L6.21,4a3.16,3.16,0,1,0-.44,1l8,3.71a3.17,3.17,0,0,0,0,1.62l-8.1,3.62a3.16,3.16,0,1,0-.08,3.9l8.15,4a3.16,3.16,0,1,0,3.09-2.49Z"
                    />
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class BehavioralIconSVGComponent {
    @Input()
    dimensions: { width: number | string; height: number | string } = {
        width: '100%',
        height: '100%'
    };
}
